"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Input = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./Input.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Input = /*#__PURE__*/React.forwardRef(({
  after,
  as,
  before,
  className,
  flex = false,
  disabled = false,
  error = false,
  showValidationIcons = true,
  valid = false,
  variant = 'primary',
  ...otherProps
}, ref) => (0, _pragma.createFelaElement)(_.View, {
  alignItems: "center",
  className: className,
  css: css.root,
  cssProps: {
    variant
  },
  inline: true,
  flex: flex,
  gap: "small",
  justifyContent: "space-between"
}, before && (0, _pragma.createFelaElement)(_.View, {
  children: before
}), (0, _pragma.createFelaElement)(_.View, _extends({
  as: as || 'input',
  css: css.input,
  cssProps: {
    error,
    valid,
    variant
  },
  disabled: disabled,
  flex: true,
  ref: ref,
  type: "text"
}, otherProps)), (0, _pragma.createFelaElement)("div", {
  css: css.background,
  cssProps: {
    variant
  }
}), after && (0, _pragma.createFelaElement)(_.View, {
  children: after
}), showValidationIcons && (0, _pragma.createFelaElement)(_.View, null, error && (0, _pragma.createFelaElement)(_.ErrorCircleIcon, {
  color: "text.negative",
  size: "large"
}), valid && !error && (0, _pragma.createFelaElement)(_.CheckboxCheckedIcon, {
  color: "text.positive",
  size: "large"
}))));
exports.Input = Input;
Input.displayName = 'Input';
var _default = Input;
exports.default = _default;
//# sourceMappingURL=Input.js.map